export const FILE_CHUNK_SIZE = 5 * 1024 * 1024; // 5MB

export const MAX_ALBUMS_IN_STACKS = 4;
export const ALBUM_ARTWORK_SIZE = 80;
export const ALBUM_ARTWORK_SPACING = 10;

export const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const STATES = [
  "AB",
  "AL",
  "AK",
  "AZ",
  "AR",
  "BC",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "MB",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NB",
  "NL",
  "NS",
  "NU",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "ON",
  "OR",
  "PA",
  "PE",
  "QC",
  "RI",
  "SC",
  "SK",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
  "YT"
];
